/**
 * 茶区分定数
 */
export const TEA_CATEGORY = {
  ARACHA: 1, // 荒茶
  SHIAGECHA: 2, // 仕上茶
} as const;

export type TeaCategoryType = (typeof TEA_CATEGORY)[keyof typeof TEA_CATEGORY];

// 選択肢
export const TEA_CATEGORY_OPTIONS = [
  { value: "", label: "全て" },
  { value: TEA_CATEGORY.ARACHA, label: "荒茶" },
  { value: TEA_CATEGORY.SHIAGECHA, label: "仕上茶" },
];
